<template>
  <modal
    title=" Industry Sector"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Name:</label>
        <input
          type="text"
          class="input"
          placeholder="Enter"
          v-model="industryName"
        />
      </div>

      <div class="actions pt-4 flex justify-between">
        <div class="cursor-pointer" @click="closeModal">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button
            buttonText="Save"
            :loading="loading"
            @click="submit"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    industrySectors: {
      required: false,
    },
    products: {
      required: false,
    },
    selectedIndustrySector: {
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      industryName: "",
    };
  },
  watch: {
    selectedIndustrySector(val) {
      this.industryName = val;
    },
  },
  methods: {
    closeModal() {
      this.industryName = "";
      this.$emit("close-modal");
    },
    async submit() {
      this.loading = true;

      let payload = {};
      if (this.selectedIndustrySector) {
        let updatedIndustrySectors = [...this.industrySectors];
        let indexOfSelectedIndustrySector = this.industrySectors.indexOf(
          this.selectedIndustrySector
        );
        updatedIndustrySectors[
          indexOfSelectedIndustrySector
        ] = this.industryName;
        payload = {
          payload: {
            setting: {
              industrySector: [...updatedIndustrySectors],
              products: [...this.products],
            },
          },
        };
      } else {
        payload = {
          payload: {
            setting: {
              industrySector: [...this.industrySectors, this.industryName],
              products: [...this.products],
            },
          },
        };
      }
      console.log(payload);
      try {
        const response = await this.$_updateIndustryAndProductSettings(payload);
        this.logResponse(response);
        this.generateToast("Success!", "success");
        this.$emit("created");
        this.closeModal();
      } catch (error) {
        this.industrySectors.push(this.selectedIndustrySector);
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
